/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailIcon20Light = forwardRef('MailIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M5.312 6.81a.5.5 0 1 0-.624.78l3.375 2.701a3.1 3.1 0 0 0 3.874 0l3.375-2.7a.5.5 0 1 0-.624-.781l-3.376 2.7a2.1 2.1 0 0 1-2.624 0l-3.376-2.7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5ZM3 7a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" })));
});
